// (() => {
//   if (customElements.get('product-form')) return;

//   // Expose these globally so you can call them from anywhere if needed
//   window.updateCartBadge = async function () {
//     try {
//       const res = await fetch('/cart.js', { cache: 'no-store' });
//       if (!res.ok) throw new Error(`HTTP ${res.status}`);
//       const cart = await res.json();

//       const badge =
//         document.querySelector('.cart-count-badge, .cart-count-bubble, [data-cart-count]');
//       if (!badge) return;

//       badge.textContent = cart.item_count;
//       badge.style.display = cart.item_count > 0 ? 'block' : 'none';
//     } catch (e) {
//       console.error('[product-form] badge update failed:', e);
//     }
//   };

//   window.showCartToast = function (message = 'Product added to cart') {
//     // Use your existing CSS for .cart-toast / .visible
//     document.querySelector('.cart-toast')?.remove();

//     const el = document.createElement('div');
//     el.className = 'cart-toast';
//     el.textContent = message;
//     document.body.appendChild(el);

//     // trigger CSS transition
//     requestAnimationFrame(() => el.classList.add('visible'));

//     // auto-hide
//     setTimeout(() => {
//       el.classList.remove('visible');
//       el.addEventListener('transitionend', () => el.remove(), { once: true });
//       setTimeout(() => el.remove(), 400); // fallback
//     }, 3000);
//   };

//   document.addEventListener('DOMContentLoaded', () => {
//     window.updateCartBadge?.();
//   });

//   class ProductForm extends HTMLElement {
//     constructor() {
//       super();

//       // Resolve the button first, then get the real form from button.form
//       const formId = `product-form-${this.dataset.sectionId}`;

//       this.submitButton =
//         this.querySelector('[name="add"]') ||
//         document.querySelector(
//           `button[name="add"][form="${formId}"], input[name="add"][form="${formId}"]`
//         );

//       this.form =
//         this.submitButton?.form ||
//         this.querySelector('form') ||
//         document.getElementById(formId);

//       this.cartDrawer = document.querySelector('cart-drawer');
//       this.productBar = document.querySelector(`#ProductBar-${this.dataset.sectionId}`);

//       if (!this.form || this.form.tagName !== 'FORM') {
//         console.warn('[product-form] Could not resolve <form> for section', this.dataset.sectionId);
//         return;
//       }

//       // Guard for double-fires
//       this._adding = false;

//       // 1) Capture the submit (fallback)
//       this.onSubmitHandler = this.onSubmitHandler.bind(this);
//       this.form.addEventListener('submit', this.onSubmitHandler, { capture: true });

//       // 2) Capture the button click (primary path; beats hijackers)
//       this.submitButton?.addEventListener(
//         'click',
//         (e) => {
//           // if disabled, ignore
//           if (this.submitButton.hasAttribute('disabled')) return;

//           // Take control of the add-to-cart flow
//           e.preventDefault();
//           e.stopImmediatePropagation();
//           this.onSubmitHandler(e);
//         },
//         { capture: true }
//       );
//     }

//     async onSubmitHandler(event) {
//       if (this._adding) return;
//       this._adding = true;

//       event?.preventDefault?.();

//       // Purchase option gate
//       const purchaseOptions = document.querySelector('purchase-options');
//       if (purchaseOptions && !purchaseOptions.isOneTimePurchase() && !this.hasAttribute('data-has-selling-plan')) {
//         purchaseOptions.showError();
//         this._adding = false;
//         return;
//       }

//       this.submitButton?.classList.add('disabled');

//       const formData = new FormData(this.form);

//       // Sections for cart drawer (if available)
//       const sections = this.cartDrawer?.getSectionsToRender?.().map(s => s.section) || [];
//       if (sections.length) {
//         formData.append('sections', sections);
//         formData.append('sections_url', window.location.pathname);
//       }

//       const addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';

//       try {
//         const res = await fetch(`${addUrl}.js`, {
//           method: 'POST',
//           headers: { 'X-Requested-With': 'XMLHttpRequest' },
//           body: formData
//         });

//         // Handle Shopify 422 validation errors gracefully
//         if (!res.ok) {
//           let msg = 'Could not add to cart. Please try again.';
//           try {
//             const j = await res.json();
//             msg = j.message || j.description || msg;
//           } catch (_) {}
//           this.handleErrorMessage(msg);
//           return;
//         }

//         const item = await res.json();

//         // ✅ success UI
//         window.showCartToast?.('Product added to cart');
//         await window.updateCartBadge?.();

//         // signal for other scripts
//         document.dispatchEvent(new CustomEvent('cart:updated', {
//           detail: { itemAdded: true, items: [item] }
//         }));
//       } catch (err) {
//         console.error('[product-form] add error', err);
//         this.handleErrorMessage('Could not add to cart. Please try again.');
//       } finally {
//         this.submitButton?.classList.remove('disabled');
//         this._adding = false;
//       }
//     }

//     handleErrorMessage(errorMessage = '') {
//       const errorWrapper = this.querySelector('[data-error-wrapper]');
//       if (!errorWrapper) return;

//       let message = errorMessage;
//       if (typeof errorMessage === 'object' && errorMessage !== null) {
//         message = Object.values(errorMessage).flat().join(', ');
//       }
//       errorWrapper.classList.toggle('hidden', !message);
//       errorWrapper.textContent = message || '';
//     }

//     toggleAddButton(disable, text) {
//       const addText =
//         (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart';
//       const addSubText =
//         (window.variantStrings && window.variantStrings.addSubscriptionToCart) || 'Add subscription';

//       [this.submitButton, this.productBar?.querySelector('[name="add"]')].forEach(btn => {
//         if (!btn) return;
//         if (disable) {
//           btn.setAttribute('disabled', 'disabled');
//           if (text) btn.textContent = text;
//         } else {
//           btn.removeAttribute('disabled');
//           btn.textContent = this.hasAttribute('data-has-selling-plan') ? addSubText : addText;
//         }
//       });
//     }
//   }

//   customElements.define('product-form', ProductForm);
// })();



// (() => {
//   if (customElements.get('product-form')) return;

//   // Expose these globally so you can call them from anywhere if needed
//   window.updateCartBadge = async function () {
//     try {
//       const res = await fetch('/cart.js', { cache: 'no-store' });
//       if (!res.ok) throw new Error(`HTTP ${res.status}`);
//       const cart = await res.json();

//       const badge = document.querySelector('.cart-count-badge, .cart-count-bubble, [data-cart-count]');
//       if (!badge) return;

//       badge.textContent = cart.item_count;
//       badge.style.display = cart.item_count > 0 ? 'block' : 'none';
//     } catch (e) {
//       console.error('[product-form] badge update failed:', e);
//     }
//   };

//   window.showCartToast = function (message = 'Product added to cart') {
//     document.querySelector('.cart-toast')?.remove();

//     const el = document.createElement('div');
//     el.className = 'cart-toast';
//     el.textContent = message;
//     document.body.appendChild(el);

//     requestAnimationFrame(() => el.classList.add('visible'));

//     setTimeout(() => {
//       el.classList.remove('visible');
//       el.addEventListener('transitionend', () => el.remove(), { once: true });
//       setTimeout(() => el.remove(), 400);
//     }, 3000);
//   };

//   document.addEventListener('DOMContentLoaded', () => {
//     window.updateCartBadge?.();
//   });

//   class ProductForm extends HTMLElement {
//     constructor() {
//       super();

//       const formId = `product-form-${this.dataset.sectionId}`;

//       // Prefer the JS-visible add button inside this component
//       this.submitButton =
//         this.querySelector('button[name="add"].no-js-hidden, input[name="add"].no-js-hidden') ||
//         this.querySelector('[name="add"]') ||
//         document.querySelector(`button[name="add"][form="${formId}"], input[name="add"][form="${formId}"]`);

//       this.form =
//         this.submitButton?.form ||
//         this.querySelector('form') ||
//         document.getElementById(formId);

//       this.cartDrawer = document.querySelector('cart-drawer');
//       this.productBar = document.querySelector(`#ProductBar-${this.dataset.sectionId}`);

//       if (!this.form || this.form.tagName !== 'FORM') {
//         console.warn('[product-form] Could not resolve <form> for section', this.dataset.sectionId);
//         return;
//       }

//       this._adding = false;

//       // bind methods
//       this.onSubmitHandler = this.onSubmitHandler.bind(this);
//       this.setLoading = this.setLoading.bind(this);
//       this.setButtonText = this.setButtonText.bind(this);

//       // 1) Capture the submit (fallback)
//       this.form.addEventListener('submit', this.onSubmitHandler, { capture: true });

//       // 2) Capture the button click (primary path)
//       this.submitButton?.addEventListener('click', (e) => {
//         if (this.submitButton.hasAttribute('disabled')) return;
//         e.preventDefault();
//         e.stopImmediatePropagation();
//         this.onSubmitHandler(e);
//       }, { capture: true });
//     }

//     setLoading(isLoading) {
//       if (!this.submitButton) return;
//       this.submitButton.classList.toggle('is-loading', !!isLoading);
//       this.submitButton.setAttribute('aria-busy', isLoading ? 'true' : 'false');
//       if (isLoading) {
//         this.submitButton.setAttribute('disabled', 'disabled');
//       } else {
//         this.submitButton.removeAttribute('disabled');
//       }
//     }

//     setButtonText(btn, text) {
//       if (!btn) return;
//       // Only change the label span so spinner markup stays intact
//       const label = btn.querySelector('[data-add-to-cart-text]') || btn.querySelector('[data-content]');
//       if (label) {
//         label.textContent = text || '';
//       } else {
//         // fallback if a button lacks span (shouldn't happen with your snippet)
//         btn.textContent = text || '';
//       }
//     }

//     async onSubmitHandler(event) {
//       if (this._adding) return;
//       this._adding = true;
//       event?.preventDefault?.();

//       // Purchase option gate
//       const purchaseOptions = document.querySelector('purchase-options');
//       if (purchaseOptions && !purchaseOptions.isOneTimePurchase() && !this.hasAttribute('data-has-selling-plan')) {
//         purchaseOptions.showError();
//         this._adding = false;
//         return;
//       }

//       this.setLoading(true);

//       const formData = new FormData(this.form);

//       // Sections for cart drawer (if available)
//       const sections = this.cartDrawer?.getSectionsToRender?.().map(s => s.section) || [];
//       if (sections.length) {
//         formData.append('sections', sections);
//         formData.append('sections_url', window.location.pathname);
//       }

//       const addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';

//       try {
//         const res = await fetch(`${addUrl}.js`, {
//           method: 'POST',
//           headers: { 'X-Requested-With': 'XMLHttpRequest' },
//           body: formData
//         });

//         if (!res.ok) {
//           let msg = 'Could not add to cart. Please try again.';
//           try {
//             const j = await res.json();
//             msg = j.message || j.description || msg;
//           } catch (_) {}
//           this.handleErrorMessage(msg);
//           return;
//         }

//         const item = await res.json();

//         // success UI
//         window.showCartToast?.('Product added to cart');
//         await window.updateCartBadge?.();

//         document.dispatchEvent(new CustomEvent('cart:updated', {
//           detail: { itemAdded: true, items: [item] }
//         }));
//       } catch (err) {
//         console.error('[product-form] add error', err);
//         this.handleErrorMessage('Could not add to cart. Please try again.');
//       } finally {
//         this.setLoading(false);
//         this._adding = false;
//       }
//     }

//     handleErrorMessage(errorMessage = '') {
//       const errorWrapper = this.querySelector('[data-error-wrapper]');
//       if (!errorWrapper) return;

//       let message = errorMessage;
//       if (typeof errorMessage === 'object' && errorMessage !== null) {
//         message = Object.values(errorMessage).flat().join(', ');
//       }
//       errorWrapper.classList.toggle('hidden', !message);
//       errorWrapper.textContent = message || '';
//     }

//     toggleAddButton(disable, text) {
//       const addText =
//         (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart';
//       const addSubText =
//         (window.variantStrings && window.variantStrings.addSubscriptionToCart) || 'Add subscription';

//       [this.submitButton, this.productBar?.querySelector('[name="add"]')].forEach(btn => {
//         if (!btn) return;
//         if (disable) {
//           btn.setAttribute('disabled', 'disabled');
//           if (text) this.setButtonText(btn, text);
//         } else {
//           btn.removeAttribute('disabled');
//           const finalText = this.hasAttribute('data-has-selling-plan') ? addSubText : addText;
//           this.setButtonText(btn, finalText);
//         }
//       });
//     }
//   }

//   customElements.define('product-form', ProductForm);
// })();

(() => {
  if (customElements.get('product-form')) return;

  // Expose these globally so you can call them from anywhere if needed
  window.updateCartBadge = async function () {
    try {
      const res = await fetch('/cart.js', { cache: 'no-store' });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const cart = await res.json();

      const badge = document.querySelector('.cart-count-badge, .cart-count-bubble, [data-cart-count]');
      if (!badge) return;

      badge.textContent = cart.item_count;
      badge.style.display = cart.item_count > 0 ? 'block' : 'none';
    } catch (e) {
      console.error('[product-form] badge update failed:', e);
    }
  };

  window.showCartToast = function (message = 'Product added to cart') {
    document.querySelector('.cart-toast')?.remove();

    const el = document.createElement('div');
    el.className = 'cart-toast';
    el.textContent = message;
    document.body.appendChild(el);

    requestAnimationFrame(() => el.classList.add('visible'));

    setTimeout(() => {
      el.classList.remove('visible');
      el.addEventListener('transitionend', () => el.remove(), { once: true });
      setTimeout(() => el.remove(), 400);
    }, 3000);
  };

  document.addEventListener('DOMContentLoaded', () => {
    window.updateCartBadge?.();
  });

  class ProductForm extends HTMLElement {
    constructor() {
      super();

      const formId = `product-form-${this.dataset.sectionId}`;

      // Prefer the JS-visible add button inside this component
      this.submitButton =
        this.querySelector('button[name="add"].no-js-hidden, input[name="add"].no-js-hidden') ||
        this.querySelector('[name="add"]') ||
        document.querySelector(`button[name="add"][form="${formId}"], input[name="add"][form="${formId}"]`);

      this.form =
        this.submitButton?.form ||
        this.querySelector('form') ||
        document.getElementById(formId);

      this.cartDrawer = document.querySelector('cart-drawer');
      this.productBar = document.querySelector(`#ProductBar-${this.dataset.sectionId}`);

      // --- NEW: mobile/sticky bar button (if present) ---
      this.barButton =
        this.productBar?.querySelector('button[name="add"].no-js-hidden, input[name="add"].no-js-hidden') ||
        this.productBar?.querySelector('[name="add"]');

      if (!this.form || this.form.tagName !== 'FORM') {
        console.warn('[product-form] Could not resolve <form> for section', this.dataset.sectionId);
        return;
      }

      this._adding = false;

      // --- NEW: ensure label span + spinner exist on both buttons ---
      this.normalizeButton(this.submitButton);
      this.normalizeButton(this.barButton);

      // bind methods
      this.onSubmitHandler = this.onSubmitHandler.bind(this);
      this.setLoading = this.setLoading.bind(this);
      this.setButtonText = this.setButtonText.bind(this);

      // 1) Capture the submit (fallback)
      this.form.addEventListener('submit', this.onSubmitHandler, { capture: true });

      // 2) Capture the button click (primary path)
      this.submitButton?.addEventListener('click', (e) => {
        if (this.submitButton.hasAttribute('disabled')) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        this.onSubmitHandler(e);
      }, { capture: true });

      // --- NEW: mobile/sticky bar button click ---
      this.barButton?.addEventListener('click', (e) => {
        if (this.barButton.hasAttribute('disabled')) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        this.onSubmitHandler(e);
      }, { capture: true });
    }

    // --- NEW: inject label span + spinner if missing (safe for existing markup) ---
    normalizeButton(btn) {
      if (!btn) return;

      btn.dataset.hasSpinner = 'true';
      if (!btn.hasAttribute('aria-busy')) btn.setAttribute('aria-busy', 'false');

      let label = btn.querySelector('[data-add-to-cart-text]') || btn.querySelector('[data-content]');
      if (!label) {
        const txt = btn.textContent.trim();
        btn.textContent = '';
        label = document.createElement('span');
        label.setAttribute('data-add-to-cart-text', '');
        label.setAttribute('data-content', '');
        label.textContent = txt || 'Add to cart';
        btn.appendChild(label);
      }

      if (!btn.querySelector('.button__spinner')) {
        const spinner = document.createElement('div');
        spinner.className = 'button__spinner';
        spinner.setAttribute('aria-hidden', 'true');
        spinner.innerHTML = '<div class="lds-ring"><span></span><span></span><span></span><span></span></div>';
        btn.appendChild(spinner);
      }
    }
setLoading(isLoading) {
  [this.submitButton, this.barButton].forEach((btn) => {
    if (!btn) return;
    btn.classList.toggle('is-loading', !!isLoading);
    btn.setAttribute('aria-busy', isLoading ? 'true' : 'false');

    // It's OK to disable while loading to prevent double-clicks
    if (isLoading) {
      btn.setAttribute('disabled', 'disabled');
    } else {
      btn.removeAttribute('disabled');
    }
  });
}


    setButtonText(btn, text) {
      if (!btn) return;
      // Only change the label span so spinner markup stays intact
      const label = btn.querySelector('[data-add-to-cart-text]') || btn.querySelector('[data-content]');
      if (label) {
        label.textContent = text || '';
      } else {
        // fallback if a button lacks span (shouldn't happen with your snippet)
        btn.textContent = text || '';
      }
    }

    async onSubmitHandler(event) {
      if (this._adding) return;
      this._adding = true;
      event?.preventDefault?.();

      // Purchase option gate
      const purchaseOptions = document.querySelector('purchase-options');
      if (purchaseOptions && !purchaseOptions.isOneTimePurchase() && !this.hasAttribute('data-has-selling-plan')) {
        purchaseOptions.showError();
        this._adding = false;
        return;
      }

      this.setLoading(true);

      const formData = new FormData(this.form);

      // Sections for cart drawer (if available)
      const sections = this.cartDrawer?.getSectionsToRender?.().map(s => s.section) || [];
      if (sections.length) {
        formData.append('sections', sections);
        formData.append('sections_url', window.location.pathname);
      }

      const addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';

      try {
        const res = await fetch(`${addUrl}.js`, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        });

        if (!res.ok) {
          let msg = 'Could not add to cart. Please try again.';
          try {
            const j = await res.json();
            msg = j.message || j.description || msg;
          } catch (_) {}
          this.handleErrorMessage(msg);
          return;
        }

        const item = await res.json();

        // success UI
        window.showCartToast?.('Product added to cart');
        await window.updateCartBadge?.();

        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { itemAdded: true, items: [item] }
        }));
      } catch (err) {
        console.error('[product-form] add error', err);
        this.handleErrorMessage('Could not add to cart. Please try again.');
      } finally {
        this.setLoading(false);
        this._adding = false;
      }
    }

    handleErrorMessage(errorMessage = '') {
      const errorWrapper = this.querySelector('[data-error-wrapper]');
      if (!errorWrapper) return;

      let message = errorMessage;
      if (typeof errorMessage === 'object' && errorMessage !== null) {
        message = Object.values(errorMessage).flat().join(', ');
      }
      errorWrapper.classList.toggle('hidden', !message);
      errorWrapper.textContent = message || '';
    }

    // toggleAddButton(disable, text) {
    //   const addText =
    //     (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart';
    //   const addSubText =
    //     (window.variantStrings && window.variantStrings.addSubscriptionToCart) || 'Add subscription';

    //   [this.submitButton, this.productBar?.querySelector('[name="add"]')].forEach(btn => {
    //     if (!btn) return;
    //     if (disable) {
    //       btn.setAttribute('disabled', 'disabled');
    //       if (text) this.setButtonText(btn, text);
    //     } else {
    //       btn.removeAttribute('disabled');
    //       const finalText = this.hasAttribute('data-has-selling-plan') ? addSubText : addText;
    //       this.setButtonText(btn, finalText);
    //     }
    //   });
    // }
    toggleAddButton(disable, text) {
  const addText =
    (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart';
  const addSubText =
    (window.variantStrings && window.variantStrings.addSubscriptionToCart) || 'Add subscription';

  [this.submitButton, this.productBar?.querySelector('[name="add"]')].forEach((btn) => {
    if (!btn) return;

    if (disable) {
      // ⬅️ ensure spinner is OFF for sold-out
      btn.classList.remove('is-loading');
      btn.setAttribute('aria-busy', 'false');

      btn.setAttribute('disabled', 'disabled');
      this.setButtonText(
        btn,
        text || (window.variantStrings && window.variantStrings.soldOut) || 'Sold out'
      );
    } else {
      btn.removeAttribute('disabled');
      const finalText = this.hasAttribute('data-has-selling-plan') ? addSubText : addText;
      this.setButtonText(btn, finalText);
    }
  });
}

  }

  customElements.define('product-form', ProductForm);
})();


